module.exports = __webpack_public_path__ + "assets/media/loyalty.f96518f8.svg";